import { combineReducers } from 'redux';

import appointmentTask from './appointmentTask';
import appointmentTasksEvents from './appointmentTasksEvents';
import modalVisibility from './modalVisibility';

export default combineReducers({
  modalVisibility,
  appointmentTask,
  appointmentTasksEvents,
});
